import styled from 'styled-components'

export const SortIcon = styled.img`
  cursor: pointer;
  width: 40px;
  height: 27px;
`

export const DeleteIcon = styled.img`
  cursor: pointer;
  width: 30px;
  height: 35px;
`
